import { Link } from "@/i18n/routing";
import { getStrapiMedia } from "@repo/lib/utils";
import { MotionContainer } from "@repo/ui";
import Image from "next/image";
const OurServices = ({
  data
}) => {
  const {
    title,
    description,
    Card
  } = data;
  return <section className="px-4 py-16" data-sentry-component="OurServices" data-sentry-source-file="OurServices.jsx">
      <div className="mx-auto md:max-w-screen-xl">
        {title && <MotionContainer delay={0.2}>
            <h4 className="text-lightYellow pb-3 text-xs font-medium md:text-base">
              {title}
            </h4>
          </MotionContainer>}
        {description && <MotionContainer delay={0.3}>
            {description && <p className="font-heading rtl:font-arabic text-2xl font-medium md:text-[32px] md:leading-[44px]">
                {description}
              </p>}
          </MotionContainer>}
        {Card && <div className="grid grid-cols-2 gap-3 pt-6 md:grid-cols-3 md:gap-5">
            {Card?.map((item, index) => {
          const DynamicTag = item?.url ? Link : "div";
          return <MotionContainer key={item?.id} delay={0.4 + index * 0.1}>
                  <DynamicTag {...item?.url && {
              href: item?.url
            }}>
                    <div className="border-supportiveDarkGray hover:bg-supportiveDarkYellow h-full border px-4 py-6 transition-all duration-300 hover:shadow-[0px_4px_14px_0px_rgba(0,0,0,0.12)] md:px-5">
                      {item?.media?.url && <Image src={getStrapiMedia(item?.media?.url)} alt={item?.media?.alternativeText} width={item?.media?.width} height={item?.media?.height} />}
                      {item?.title && <p className="font-heading rtl:font-arabic py-2 text-sm font-medium md:py-4 md:text-xl">
                          {item?.title}
                        </p>}
                      {item?.subText && <p className="text-xs font-normal md:text-base">
                          {item?.subText}
                        </p>}
                    </div>
                  </DynamicTag>
                </MotionContainer>;
        })}
          </div>}
      </div>
    </section>;
};
export default OurServices;